import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import ContentItem from '../ContentItem/ContentItem';
import ShowcaseCard from '../ShowcaseCard/ShowcaseCard';
import PromotionItem from '../PromotionItem/PromotionItem';
import CoreScroll from '@nrk/core-scroll/jsx';

export const Container = styled.div`
    position: relative;
`;

const GAP = {
    DEFAULT: 5,
    GTE_MEDIUM: 5,
    GTE_XLARGE: 10,
    FULLSCREEN: 10,
};

const NO_OF_ITEMS = {
    DEFAULT: 3,
    GTE_MEDIUM: 4,
    GTE_XLARGE: 5,
    FULLSCREEN: 6,
};

/**
 * Calculates the article with based on gap size and the number of visible items
 */
const getArticleWidth = (gap, noOfItems) => {
    /* 
        This should be subtracted from the article witdh (multiply the number
        of visible gaps with gap size and divide it by the number of items)
    */
    const subractWidth = ((noOfItems - 1) * gap) / noOfItems;

    return `calc((100% / ${noOfItems}) - ${subractWidth}px)`;
};

export const CoreCarousel = css`
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    scrollbar-width: none; /* Firefox */

    /* Chrome, Safari & Opera */
    &::-webkit-scrollbar {
        display: none;
    }

    width: 100%;
    display: flex;

    /* transform: translateZ(
        0
    ); Promotes to new layer but causes extra memory usage.  Maybe not worth it */

    padding-top: 3px; /* Make space for item focus outline */
`;

export const CarouselArticle = css`
    max-width: 43%;
    margin-right: 5px;
    flex: 0 0 100%;

    .no-touchevents & {
        margin-right: ${GAP.DEFAULT}px;
        max-width: ${getArticleWidth(GAP.DEFAULT, NO_OF_ITEMS.DEFAULT)};
    }

    @media ${device.GteMedium} {
        max-width: 28.5%;

        .no-touchevents & {
            margin-right: ${GAP.GTE_MEDIUM}px;

            max-width: ${getArticleWidth(GAP.GTE_MEDIUM, NO_OF_ITEMS.GTE_MEDIUM)};
        }
    }

    @media ${device.GteXLarge} {
        .no-touchevents & {
            margin-right: ${GAP.GTE_XLARGE}px;

            max-width: ${getArticleWidth(GAP.GTE_XLARGE, NO_OF_ITEMS.GTE_XLARGE)};
        }
    }

    @media ${device.FullScreen} {
        .no-touchevents & {
            margin-right: ${GAP.FULLSCREEN}px;

            max-width: ${getArticleWidth(GAP.FULLSCREEN, NO_OF_ITEMS.FULLSCREEN)};
        }
    }
`;

export const CarouselContentItem = styled(ContentItem)`
    ${CarouselArticle}
`;

export const CarouselShowcaseCard = styled(ShowcaseCard)`
    ${CarouselArticle}
`;

export const CarouselPromotionItem = styled(PromotionItem)`
    ${CarouselArticle}
`;

export const StyledCarousel = styled(CoreScroll)`
    ${CoreCarousel}
`;

export const TouchDeviceCarousel = styled.div`
    ${CoreCarousel}
`;
